import React from 'react';
import ReactDOM from 'react-dom';
import { Link, BrowserRouter as Router } from 'react-router-dom';
//import 'flowbite';
import 'tw-elements';
//import 'semantic-ui-css/semantic.min.css';
import './index.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
